import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'

@observer
class Index extends Component {
  render() {
    const { store } = this.props
    const info = toJS(store.info)
    return (
      <div className="title-wrap">
        <img src={info.cover_path} />
        <p>{info.title}</p>
      </div>
    )
  }
}

export default Index
